/**
 * Post Processing Timeout values supported by VCCSS CM-API for Queues
 * expressed in seconds. 0 means immediate, -1 means the queue is excepted
 * from Post Processing.
 * @enum {number}
 */
export const PostProcessingTimeout = Object.freeze({
  DISABLE: -1,
  IMMEDIATE: 0,
  FIVE_SECONDS: 5,
  TEN_SECONDS: 10,
  FIFTEEN_SECONDS: 15,
  TWENTY_SECONDS: 20,
  TWENTY_FIVE_SECONDS: 25,
  THIRTY_SECONDS: 30,
  FORTY_SECONDS: 40,
  FIFTY_SECONDS: 50,
  ONE_MINUTE: 60,
  TWO_MINUTES: 120,
  THREE_MINUTES: 180,
  FOUR_MINUTES: 240,
  FIVE_MINUTES: 300,
  TEN_MINUTES: 600,
  FIFTEEN_MINUTES: 900,
  THIRTY_MINUTES: 1800,
  FORTY_FIVE_MINUTES: 2700,
  ONE_HOUR: 3600,
});

/**
 * SLA Evaluation Interval values supported by VCCSS CM-API for Queues
 * expressed in seconds.
 * @enum {number}
 */
export const SLAEvaluationInterval = Object.freeze({
  FIVE_MINUTES: 300,
  SIX_MINUTES: 360,
  TEN_MINUTES: 600,
  FIFTEEN_MINUTES: 900,
  TWENTY_MINUTES: 1200,
  TWENTY_FIVE_MINUTES: 1500,
  THIRTY_MINUTES: 1800,
  FORTY_FIVE_MINUTES: 2700,
  ONE_HOUR: 3600,
  TWO_HOURS: 7200,
  THREE_HOURS: 10800,
  FOUR_HOURS: 14400,
  FIVE_HOURS: 18000,
  SIX_HOURS: 21600,
  TWELVE_HOURS: 43200,
  ONE_DAY: 86400,
  TWO_DAYS: 172800,
  THREE_DAYS: 259200,
});
